module.exports = __webpack_public_path__ + "static/img/6areaA_4.7cb93f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/6areaA_4.png
// module id = 1048
// module chunks = 1